<template>
  <div style="padding-top: 100px">
    <div
      class="container btn-flat"
      @click="IrParaPedido()"
      v-if="this.$store.state.pedido.itens.length > 0"
    >
      <footer class="caixa-flutuante-inferior flow-text cor-primaria-bg">
        <div class="col">
          <div class="row">
            <i class="left material-icons md-24">shopping_cart</i>
            <span class="right">{{this.$store.state.pedido.itens.length}}</span>
          </div>
        </div>
        <div class="col">
          <span class="row center">Meu Pedido</span>
        </div>
        <div class="col">
          <span class="row">R$ {{ (this.$store.getters.pedidoSubtotal).toFixed(2) }}</span>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "MeuPedidoBlocoFlutuanteComponent",
  methods: {
    IrParaPedido() {
      this.$router.push("/" + this.$store.state.empresa_url + "/pedido");

    }
  }
};
</script>

<style scoped>
.caixa-flutuante-inferior.closed {
  flex-direction: column;
  height: 120px;
  -webkit-box-align: center;
  align-items: center;
}
.caixa-flutuante-inferior {
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  position: fixed;
  bottom: 50px;
  left: 0px;
  right: 0px;
  height: 50px;
  width: 100%;
  box-shadow: rgba(48, 51, 60, 0.25) 0px -1px 2px;
  max-width: 800px;
  padding: 0.5rem 2rem;
  margin: 0px auto;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Widgets/MeuPedidoBlocoFlutuanteComponent.vue